// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drink-selector {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
.drink-selector .drink-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 0;
  gap: 16px;
}
.drink-selector .drink-loading p {
  font-size: 14px;
  color: #8C8C8C;
  margin: 0;
}
.drink-selector .drink-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
}
.drink-selector .drink-header .drink-icon {
  font-size: 64px;
  color: #8E7E54;
  background-color: #FFFBEF;
  border-radius: 50%;
  padding: 24px;
  margin-bottom: 16px;
}
.drink-selector .drink-header .drink-title {
  font-size: 20px;
  font-weight: 600;
  color: #262626;
  margin: 0 0 8px 0;
}
.drink-selector .drink-header .drink-subtitle {
  font-size: 14px;
  color: #8C8C8C;
  margin: 0;
  text-align: center;
}
.drink-selector .drink-sections {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 16px;
}
.drink-selector .drink-sections .drink-category .drink-category-title {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin: 0 0 16px 0;
}
.drink-selector .drink-sections .drink-category .drink-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.drink-selector .drink-footer {
  padding-top: 16px;
}
.drink-selector .drink-footer .drink-continue-btn {
  width: 100%;
  padding: 16px 24px;
  background-color: #8E7E54;
  color: #ffffff;
  border: none;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.drink-selector .drink-footer .drink-continue-btn:hover:not(:disabled) {
  background-color: #8F7847;
}
.drink-selector .drink-footer .drink-continue-btn:disabled {
  background-color: #D9D9D9;
  cursor: not-allowed;
}
/*# sourceMappingURL=DrinkSelector.css.map */`, "",{"version":3,"sources":["webpack://./DrinkSelector.less","webpack://./src/containers/BookingPage/components/DrinkSelector.less"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;ACCD;ADNA;EAQE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,aAAA;EACA,SAAA;ACCF;ADfA;EAiBG,eAAA;EACA,cAAA;EACA,SAAA;ACCH;ADpBA;EAwBE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;ACDF;AD1BA;EA8BG,eAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;ACDH;ADlCA;EAuCG,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;ACFH;ADxCA;EA8CG,eAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;ACHH;AD9CA;EAsDE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;ACLF;ADrDA;EA8DI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;ACNJ;AD3DA;EAqEI,aAAA;EACA,sBAAA;EACA,SAAA;ACPJ;ADhEA;EA6EE,iBAAA;ACVF;ADnEA;EAgFG,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;ACVH;ADYG;EACC,yBAAA;ACVJ;ADaG;EACC,yBAAA;EACA,mBAAA;ACXJ;AACA,4CAA4C","sourcesContent":[".drink-selector {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n\tmin-height: 0;\n\n\t.drink-loading {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tflex: 1;\n\t\tmin-height: 0;\n\t\tgap: 16px;\n\n\t\tp {\n\t\t\tfont-size: 14px;\n\t\t\tcolor: #8C8C8C;\n\t\t\tmargin: 0;\n\t\t}\n\t}\n\n\t.drink-header {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tmargin-bottom: 32px;\n\n\t\t.drink-icon {\n\t\t\tfont-size: 64px;\n\t\t\tcolor: #8E7E54;\n\t\t\tbackground-color: #FFFBEF;\n\t\t\tborder-radius: 50%;\n\t\t\tpadding: 24px;\n\t\t\tmargin-bottom: 16px;\n\t\t}\n\n\t\t.drink-title {\n\t\t\tfont-size: 20px;\n\t\t\tfont-weight: 600;\n\t\t\tcolor: #262626;\n\t\t\tmargin: 0 0 8px 0;\n\t\t}\n\n\t\t.drink-subtitle {\n\t\t\tfont-size: 14px;\n\t\t\tcolor: #8C8C8C;\n\t\t\tmargin: 0;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n\n\t.drink-sections {\n\t\tflex: 1;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 24px;\n\t\tmargin-bottom: 16px;\n\n\t\t.drink-category {\n\t\t\t.drink-category-title {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: #262626;\n\t\t\t\tmargin: 0 0 16px 0;\n\t\t\t}\n\n\t\t\t.drink-list {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 12px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.drink-footer {\n\t\tpadding-top: 16px;\n\n\t\t.drink-continue-btn {\n\t\t\twidth: 100%;\n\t\t\tpadding: 16px 24px;\n\t\t\tbackground-color: #8E7E54;\n\t\t\tcolor: #ffffff;\n\t\t\tborder: none;\n\t\t\tborder-radius: 24px;\n\t\t\tfont-size: 16px;\n\t\t\tfont-weight: 600;\n\t\t\tcursor: pointer;\n\t\t\ttransition: all 0.3s ease;\n\n\t\t\t&:hover:not(:disabled) {\n\t\t\t\tbackground-color: #8F7847;\n\t\t\t}\n\n\t\t\t&:disabled {\n\t\t\t\tbackground-color: #D9D9D9;\n\t\t\t\tcursor: not-allowed;\n\t\t\t}\n\t\t}\n\t}\n}\n",".drink-selector {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n.drink-selector .drink-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  min-height: 0;\n  gap: 16px;\n}\n.drink-selector .drink-loading p {\n  font-size: 14px;\n  color: #8C8C8C;\n  margin: 0;\n}\n.drink-selector .drink-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 32px;\n}\n.drink-selector .drink-header .drink-icon {\n  font-size: 64px;\n  color: #8E7E54;\n  background-color: #FFFBEF;\n  border-radius: 50%;\n  padding: 24px;\n  margin-bottom: 16px;\n}\n.drink-selector .drink-header .drink-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #262626;\n  margin: 0 0 8px 0;\n}\n.drink-selector .drink-header .drink-subtitle {\n  font-size: 14px;\n  color: #8C8C8C;\n  margin: 0;\n  text-align: center;\n}\n.drink-selector .drink-sections {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  margin-bottom: 16px;\n}\n.drink-selector .drink-sections .drink-category .drink-category-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #262626;\n  margin: 0 0 16px 0;\n}\n.drink-selector .drink-sections .drink-category .drink-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.drink-selector .drink-footer {\n  padding-top: 16px;\n}\n.drink-selector .drink-footer .drink-continue-btn {\n  width: 100%;\n  padding: 16px 24px;\n  background-color: #8E7E54;\n  color: #ffffff;\n  border: none;\n  border-radius: 24px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n.drink-selector .drink-footer .drink-continue-btn:hover:not(:disabled) {\n  background-color: #8F7847;\n}\n.drink-selector .drink-footer .drink-continue-btn:disabled {\n  background-color: #D9D9D9;\n  cursor: not-allowed;\n}\n/*# sourceMappingURL=DrinkSelector.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
